export const TRANSACTION_TYPES = {
  INCOME: 'income',
  EXPENSE: 'expense',
  TRANSFER_IN: 'transfer_in',
  TRANSFER_OUT: 'transfer_out',
};

export const transactionsTypesTranslations = {
  [TRANSACTION_TYPES.INCOME]: 'Надходження',
  [TRANSACTION_TYPES.EXPENSE]: 'Списання',
};
